import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';

interface Theme {
  background: 'black' | 'white';
  color: 'tradfi' | 'crypto';
}

interface ThemeContextType {
  theme: Theme;
  toggleBackground: () => void;
  toggleColor: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const savedBackground = localStorage.getItem('background') || 'white';
    const savedColor = localStorage.getItem('color') || 'tradfi';
    const newTheme = { background: savedBackground as 'black' | 'white', color: savedColor as 'tradfi' | 'crypto' };
    const [theme, setTheme] = useState<Theme>(newTheme);

  useEffect(() => {
    const themeClass = `${newTheme.background}-${newTheme.color}`;
    document.body.className = themeClass;

  }, [theme]);

  const toggleBackground = () => {
    const newBackground = theme.background === 'black' ? 'white' : 'black';
    localStorage.setItem('background', newBackground);
    setTheme(prevTheme => ({ ...prevTheme, background: newBackground }));
  };

  const toggleColor = () => {
    const newColor = theme.color === 'tradfi' ? 'crypto' : 'tradfi';
    localStorage.setItem('color', newColor);
    setTheme(prevTheme => ({ ...prevTheme, color: newColor }));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleBackground, toggleColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
